export default {
    getHeaderFields: state => state.headerFields,
    getSearchFields: state => state.searchFields,
    getDataTableOptions: state => state.dataTableOptions,
    getRowActions: state => state.rowActions,
    getActions: state => state.actions
}
